import { __decorate } from "tslib";
import colors from '@/styles/color.scss';
import lang from '@blade-sxp/portrait-management/lang/index';
import FailDetails from '@blade-sxp/device-management-pass/components/detail/fail-details.vue';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { PageOrderEnum } from '@blade-sxp/portrait-management/interfaces/common';
import { DbSyncInfoRequestUserTypeEnum, DbSyncInfoRequestStatusEnum, } from '@blade-sxp/device-management-pass/interfaces/dbSync';
import { dbsyncDelete, dbsyncErrDetail, dbsyncAgain } from '@blade-sxp/device-management-pass/api/dbSync';
import { Scale } from '@blade/common/utils/auto-scale';
const Webapi = {
    dbsyncDelete,
    dbsyncErrDetail,
    dbsyncAgain,
};
let default_1 = class default_1 extends Vue {
    data;
    loading;
    pagination;
    refresh;
    // 漏斗图标
    funnelIcon = require('@blade-sxp/task-management/assets/union.png');
    defaultSort = { prop: 'updateTime', order: 'descending' };
    defaultTableMinWidth = {
        libraryName: 268 * Scale,
        userType: 140 * Scale,
        result: 140 * Scale,
        createdBy: 200 * Scale,
        createdAt: 200 * Scale,
        updatedAt: 200 * Scale,
        operate: 172 * Scale,
    };
    colors = colors;
    defaultIconSize = 12;
    statusLoaded = DbSyncInfoRequestStatusEnum.LOADED;
    statusUploading = DbSyncInfoRequestStatusEnum.UPLOADING;
    defaultPageSize = [10, 20, 50, 100, 200];
    failDetailList = [];
    failDetailVisible = false;
    filterUserType = [];
    cellBackground = colors.colorBoxBg;
    submiting = false;
    uploadingStatus = {};
    initI18n() {
        this.filterUserType = [
            { text: String(this.$t('blacklist')), value: DbSyncInfoRequestUserTypeEnum.BLACKLIST },
            { text: String(this.$t('staff')), value: DbSyncInfoRequestUserTypeEnum.STAFF },
            { text: String(this.$t('guest')), value: DbSyncInfoRequestUserTypeEnum.GUEST },
        ];
    }
    godeploy(val) {
        const deviceId = this.$route.query.deviceId;
        this.$router.push({
            path: '/setting/deviceManagementPass/deploy',
            query: { deviceId: deviceId, libId: val.libId, libName: val.libName, type: val.userType },
        });
    }
    getUserTypeName(type) {
        return this.filterUserType.find((t) => t.value === type)?.text;
    }
    ellipsisName(str) {
        return str.length > 30 ? str.slice(0, 30) + '...' : str;
    }
    handleSizeChange(val) {
        this.pagination.size = val;
        this.$emit('update:pagination', this.pagination);
    }
    handleCurrentChange(val) {
        this.pagination.page = val;
        this.$emit('update:pagination', this.pagination);
    }
    currentSizeFormatter(e) {
        return String(e.currentSize).replace(/\d{1,3}(?=(\d{3})+$)/g, '$&,');
    }
    filterChange(e) {
        if (e.userType && e.userType instanceof Array && e.userType.length > 0) {
            this.pagination.userType = e.userType[0];
        }
        else
            this.pagination.userType = undefined;
        this.$emit('update:pagination', this.pagination);
        this.refresh();
    }
    sortChange(order) {
        this.pagination.pageOrderList = [
            {
                orderField: 'update_time',
                orderType: order.order === 'ascending' ? PageOrderEnum.ASC : PageOrderEnum.DESC,
            },
        ];
        this.$emit('update:pagination', this.pagination);
        this.refresh();
    }
    async handleErrDetail(item) {
        this.submiting = true;
        try {
            this.failDetailList = (await Webapi.dbsyncErrDetail(String(item.relationId))) ?? [];
            this.failDetailVisible = true;
        }
        catch (error) {
            console.log('handleErrDetail error', error);
        }
        this.submiting = false;
    }
    async handleRefresh(item) {
        try {
            await Webapi.dbsyncAgain(String(item.relationId));
            this.uploadingStatus = {
                ...this.uploadingStatus,
                [item.relationId]: true,
            };
        }
        catch (error) {
            console.log('handleRefresh error', error);
        }
    }
    handleDelete(item) {
        this.$elconfirm(`${this.$t('deleteTip')}`, `${this.$t('tip')}`, {
            type: 'warning',
            cancelButtonText: `${this.$t('common.cancel')}`,
            confirmButtonText: ` ${this.$t('common.confirm')}`,
            cancelButtonClass: 'cancel-roi-tip',
            confirmButtonClass: 'confirm-roi-tip',
            callback: async (action) => {
                if (action === 'confirm') {
                    try {
                        await Webapi.dbsyncDelete(String(item.relationId));
                        this.$message({
                            customClass: 'success-message',
                            message: this.$t('deletedSuccessfully'),
                            type: 'success',
                            showClose: true,
                        });
                        this.handleCurrentChange(1);
                        this.refresh();
                    }
                    catch (error) {
                        console.log('dbsyncDelete error', error);
                    }
                }
            },
        });
    }
    isResultCount(item) {
        let { failCount, successCount, totalCount } = item;
        failCount = +failCount;
        successCount = +successCount;
        totalCount = +totalCount;
        if (totalCount === 0)
            return false;
        return (failCount === 0 && successCount === 0) || totalCount === 0;
    }
    mounted() {
        this.initI18n();
    }
};
__decorate([
    Prop()
], default_1.prototype, "data", void 0);
__decorate([
    Prop()
], default_1.prototype, "loading", void 0);
__decorate([
    Prop()
], default_1.prototype, "pagination", void 0);
__decorate([
    Prop()
], default_1.prototype, "refresh", void 0);
__decorate([
    Watch('$i18n.locale')
], default_1.prototype, "initI18n", null);
default_1 = __decorate([
    Component({
        components: {
            FailDetails,
        },
        i18n: {
            messages: {
                en: {
                    ...lang.en,
                    type: 'Type',
                    result: 'Result',
                    createdAt: 'Created At',
                    deleteTip: 'Are you sure to delete the portrait library from the list?',
                    blacklist: 'Black Library',
                    staff: 'Staff Library',
                    guest: 'Guest Library',
                    redistributionTip: 'Redistributed the failed portraits',
                    uploading: 'Uploading',
                },
                zh: {
                    ...lang.zh,
                    type: '类型',
                    result: '结果',
                    createdAt: '创建时间',
                    deleteTip: '确定要从列表中删除人像库吗？',
                    blacklist: '黑名单库',
                    staff: '员工库',
                    guest: '访客库',
                    redistributionTip: '重新下发失败人像',
                    uploading: '正在上传',
                },
            },
        },
    })
], default_1);
export default default_1;
